// src/App.js

import React, { Suspense, useEffect, useState } from 'react';
import { Route, Routes, Navigate, useLocation, HashRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useColorModes } from '@coreui/react';
// import LoadingOverlay from 'react-loading-overlay';
import './scss/style.scss';

// Lazy yüklenen bileşenler
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'));
const Login = React.lazy(() => import('./views/pages/login/Login'));
const ForgotPassword = React.lazy(() => import('./views/pages/forgot_password/ForgotPassword'));
const Profile = React.lazy(() => import('./views/pages/User/Profile'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));
const Mappage = React.lazy(() => import('./views/pages/map/MapComponent'));
const CreatePassword = React.lazy(() => import('./views/pages/login/CreatePassword'));

// ProtectedRoute bileşeni
const ProtectedRoute = ({ children, requiredPermission }) => {
  const userSession = sessionStorage.getItem('user');
  const permissions = JSON.parse(sessionStorage.getItem('permissions')) || [];

  // Kullanıcı oturumu yoksa login sayfasına yönlendir
  if (!userSession) {
    return <Navigate to="/login" />;
  }
  
  // Gerekli izin yoksa 404 sayfasına yönlendir
  if (requiredPermission && !permissions.some((perm) => perm.name === requiredPermission)) {
    return <Navigate to="/404" />;
  }

  return children;
};

// AppContent bileşeni
const AppContent = () => {
  const location = useLocation(); // Router içinde konumu takip etmek için
  const [loading, setLoading] = useState(false);
  const [elements, setElements] = useState([]);

  useEffect(() => {
    // Sayfa geçişlerinde loading ekranını göster
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer); // Temizlik işlemi

    // sessionStorage'dan navigasyon bilgilerini al
    const savedElements = JSON.parse(sessionStorage.getItem('elements')) || [];
    setElements(savedElements);
  }, [location]);

  return (
    // <LoadingOverlay
    //   active={loading}
    //   spinner={
    //     <img
    //       src={"/sehrinsahnesinde.gif"}
    //       alt="Loading..."
    //       style={{ width: '55%', height: '55%' }}
    //     />
    //   }
    //   styles={{
    //     overlay: (base) => ({
    //       ...base,
    //       position: 'fixed',
    //       top: 0,
    //       left: 0,
    //       width: '100vw',
    //       height: '100vh',
    //       background: 'rgba(0, 0, 0, 0.5)', // %50 opak arka plan
    //       zIndex: 9999,
    //       overflow: 'hidden',
    //     }),
    //   }}
    // >
      <Suspense fallback={<div>Yükleniyor...</div>}>
        <Routes>
          {/* Login ve genel sayfalar */}
          <Route exact path="/login" name="Login Page" element={<Login />} />
          <Route exact path="/forgotpassword" name="Forgot Password Page" element={<ForgotPassword />} />
          <Route exact path="/profile" name="Profile" element={<Profile />} />
          <Route exact path="/register" name="Register Page" element={<Register />} />
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route exact path="/mappage" name="MapPage" element={<Mappage />} />
          <Route exact path="/createpassword" name="Create Password" element={<CreatePassword />} />

          {/* Dinamik yönlendirmeler */}
          {elements.map((element) => (
            <Route
              key={element.id}
              path={`/${element.name.toLowerCase()}`}
              element={
                <ProtectedRoute requiredPermission={`GET:/${element.name.toLowerCase()}`}>
                  <DefaultLayout />
                </ProtectedRoute>
              }
            />
          ))}

          {/* Varsayılan yönlendirme */}
          <Route
            path="*"
            element={
              <ProtectedRoute>
                <DefaultLayout />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Suspense>
    // </LoadingOverlay>
  );
};

// Ana App bileşeni
const App = () => {
  const { isColorModeSet, setColorMode } = useColorModes('coreui-free-react-admin-template-theme');
  const storedTheme = useSelector((state) => state.theme);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.href.split('?')[1]);
    const theme = urlParams.get('theme')?.match(/^[A-Za-z0-9\s]+/)[0];
    if (theme) setColorMode(theme);

    if (!isColorModeSet()) setColorMode(storedTheme);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <HashRouter>
      <AppContent />
    </HashRouter>
  );
};

export default App;
